import { i18n } from '@lingui/core';
import { applyDocumentLocale, readStoredLocale } from './utils/locale';

const enMessages = require('./locales/en/messages').messages;
const plMessages = require('./locales/pl/messages').messages;
const heMessages = require('./locales/he/messages').messages;

i18n.load('en', enMessages);
i18n.load('pl', plMessages);
i18n.load('he', heMessages);

const initialLocale = readStoredLocale();
i18n.activate(initialLocale);
applyDocumentLocale(initialLocale);

export { i18n };
